import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'
import { GET_PAYMENT_TYPES_TRANSLATE } from '../../../../queries'

export default function PaymentMethods (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringFiltersContext)
  const { loading, error, data } = useQuery(GET_PAYMENT_TYPES_TRANSLATE)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { paymentTypes: tempPaymentTypes } = data.ordersAggs.aggregations
  const paymentsTypes: Array<string> = []

  tempPaymentTypes.buckets.map((client: any) => {
    paymentsTypes.push(client.key)
  })

  const onChange = (value: any) => {
    setFilters({
      paymentMethods: value
    })
  }

  const typographLabel = 'Formas de Pagamento'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={paymentsTypes}
        defaultValues={filters.paymentMethods}
        onChange={onChange}
      />
    </Fragment>
  )
}
